import React from 'react';
import { TodayIndicator, HeaderCellContainer } from './style';
import { isDateToday } from '../../../../Utils/timeConvertorHelper';

export const HeaderCell = ({ date, dayFormat }) => {
    const displayDate = date.format(dayFormat);
    return (
        <HeaderCellContainer>
            {isDateToday(date) ? (
                <TodayIndicator>{displayDate}</TodayIndicator>
            ) : (
                <React.Fragment>{displayDate}</React.Fragment>
            )}
        </HeaderCellContainer>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/HeaderCell.js